import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Mail, CheckCircle2, AlertCircle } from 'lucide-react';

export default function NewsletterCapture() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      // Validation email basique
      if (!email || !email.includes('@')) {
        setStatus('error');
        return;
      }

      // Envoi au backend
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'blog' })
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
        // Reset après 5 secondes
        setTimeout(() => setStatus('idle'), 5000);
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Newsletter error:', error);
      setStatus('error');
    }
  };

  return (
    <Card className="border-2 border-[#8A9474] bg-gradient-to-br from-[#E8EBE4] to-[#F5F3EF] overflow-hidden">
      <CardContent className="p-8">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-full bg-[#8A9474] flex items-center justify-center">
              <Mail className="h-6 w-6 text-white" />
            </div>
          </div>
          
          <div className="flex-1">
            <h3 className="text-xl font-bold text-[#2B2B2B] mb-2">
              Recevez Nos Guides Exclusifs
            </h3>
            <p className="text-[#4A4A4A] mb-4 text-sm">
              Stratégies SEO, pricing dynamique, optimisations fiscales : 1 guide actionnable par semaine directement dans votre boîte mail.
            </p>

            {status === 'success' ? (
              <div className="flex items-center gap-2 text-green-700 bg-green-50 p-3 rounded-lg">
                <CheckCircle2 className="h-5 w-5" />
                <span className="text-sm font-semibold">Merci ! Vérifiez votre boîte mail pour confirmer.</span>
              </div>
            ) : status === 'error' ? (
              <div className="flex items-center gap-2 text-red-700 bg-red-50 p-3 rounded-lg mb-3">
                <AlertCircle className="h-5 w-5" />
                <span className="text-sm">Email invalide. Veuillez réessayer.</span>
              </div>
            ) : null}

            {status !== 'success' && (
              <form onSubmit={handleSubmit} className="flex gap-2">
                <Input
                  type="email"
                  placeholder="votre@email.ch"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 border-[#8A9474] focus:ring-[#8A9474]"
                  required
                  data-testid="newsletter-email-input"
                />
                <Button 
                  type="submit"
                  disabled={status === 'loading'}
                  className="bg-[#8A9474] hover:bg-[#7A8464] text-white px-6 whitespace-nowrap"
                  data-testid="newsletter-submit-btn"
                >
                  {status === 'loading' ? 'Envoi...' : "S'inscrire"}
                </Button>
              </form>
            )}

            <p className="text-xs text-[#4A4A4A] mt-2">
              🔒 Pas de spam. Désinscription en 1 clic. Vos données sont protégées.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
